import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';
import { InteractorService } from './interactor.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionService {
  permissions: any;
  permissionList;
  rolesAndPermissions;
  sharedPermissions: any;
  subscribePermission = new BehaviorSubject<any>(null);
  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService,
    private interactorService: InteractorService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  /**
   *
    Function to check the user has access to the modules
   */
  isAuthorized(permission, operationTypes, isPersonProfile?: boolean) {
    if (!permission || !operationTypes) {
      return false;
    }

    let isActiveForSharing = false;
    if (this.router.url.split('?')[0] === '/people/details/activesharing') {
      isActiveForSharing = true;
    }
    if (isActiveForSharing && isPersonProfile) {
      const selectedPermissions = this.sharedPermissions?.filter(
        (p) => p.permission === permission
      );
      if (selectedPermissions && selectedPermissions.length > 0) {
        return (
          selectedPermissions[0].operationType.filter(
            (op) => op === operationTypes
          ).length > 0
        );
      } else {
        return false;
      }
    } else {
      const selectedPermissions = this.permissions?.filter(
        (p) => p.permission === permission
      );
      if (selectedPermissions && selectedPermissions.length > 0) {
        return (
          selectedPermissions[0].operationType.filter(
            (op) => op === operationTypes
          ).length > 0
        );
      } else {
        return false;
      }
    }
  }

  /**
   * Function to fetch the roles and permission
   * @param tenantId : tenant id
   */
  getPermissions(tenantId): Observable<any> {
    const headers = new HttpHeaders().set('tenantId', tenantId);
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'Permissions';
    return this.http.get<any>(url, options).pipe(
      map((output) => {
        this.permissions = this.callBackTransformService.transformOutput(
          output
        ).Data;
        this.subscribePermission.next(this.permissions);
        this.interactorService.changePermissionData(this.permissions);
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * get Shared Permissions
   */
  getSharedPermissions(): Observable<any> {
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    const agencySharingIndex = queryParams.get('agencySharingIndex');
    const collaborationSharingIndex = queryParams.get('collaborationSharingIndex');
    const isActiveForSharing = queryParams.get('isActiveForSharing') === 'true' ? 'true' : 'false';

    const url = `${this.envService.apiUrl}shared-permissions/${agencySharingIndex}/${collaborationSharingIndex}/${isActiveForSharing}`;
    
    return this.http.get<any>(url).pipe(
      map((output) => {
        const transformedOutput = this.callBackTransformService.transformOutput(output);
        this.sharedPermissions = transformedOutput.Data;
        return transformedOutput;
      }),
      catchError((err) => throwError(this.callBackTransformService.transformOutput(err)))
    );
  }
}
